/**
 * Check if current filter values match their defaults
 * Used to determine if "Reset filters" button should be shown
 *
 * @param {Object} current - Object with current filter values
 * @param {Object} defaults - Object with default filter values
 * @returns {boolean} True if filters match defaults (i.e., cannot reset)
 *
 * @example
 * // In Alpine getter:
 * get canResetFilters() {
 *   return !filtersMatchDefaults(
 *     { status: this.selectedStatus, types: this.selectedTypes },
 *     this.defaults
 *   );
 * }
 */
export function filtersMatchDefaults(current, defaults) {
  for (const key of Object.keys(defaults)) {
    const defaultVal = defaults[key];
    const currentVal = current[key];

    if (Array.isArray(defaultVal)) {
      // Compare arrays by sorting and checking each element
      const sortedDefault = [...defaultVal].sort();
      const sortedCurrent = [...(currentVal || [])].sort();
      if (sortedDefault.length !== sortedCurrent.length) return false;
      if (!sortedDefault.every((val, idx) => val === sortedCurrent[idx])) return false;
    } else {
      // Simple value comparison
      if (currentVal !== defaultVal) return false;
    }
  }
  return true;
}

/**
 * Make filtersMatchDefaults available globally for inline use in ERB templates
 * Note: serviceTypeBadgeClass is defined in app/views/layouts/application.html.erb
 * as the single source of truth for service type badge colors
 */
if (typeof window !== 'undefined') {
  window.filtersMatchDefaults = filtersMatchDefaults;
}
